var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 28",
    style: {
      enableBackground: "new 0 0 75 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.union-icon-st0{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "union-icon-st0",
    d: "M0.294922 14.3364C0.294922 6.88052 6.31873 0.836365 13.7495 0.836365C15.7242 0.836365              17.5995 1.2632 19.2888 2.02994C25.2169 4.72056 30.7885 9.83637 37.2949 9.83637C43.8013              9.83637 49.373 4.72056 55.3011 2.02994C56.9904 1.2632 58.8657 0.836365 60.8404              0.836365C68.2711 0.836365 74.2949 6.88052 74.2949 14.3364C74.2949 21.7922 68.2711 27.8364              60.8404 27.8364C58.8657 27.8364 56.9904 27.4095 55.3011 26.6428C49.373 23.9522 43.8013              18.8364 37.2949 18.8364C30.7885 18.8364 25.2169 23.9522 19.2888 26.6428C17.5995 27.4095              15.7242 27.8364 13.7495 27.8364C6.31873 27.8364 0.294922 21.7922 0.294922 14.3364Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionIcon);
export default __webpack_public_path__ + "static/media/union-icon.ced2c92ae3a45d2e2d2aac0099a0b737.svg";
export { ForwardRef as ReactComponent };